module.exports = __webpack_public_path__ + "img/标题背景.374fad70.png";